import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { LuMail, LuPhone } from 'react-icons/lu'

import ContactCompanyModal from '@/components/misc/CompanyProfile/components/ContactCompanyModal'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import useDialog from '@/hooks/useDialog'
import { toSafeHttpUrl } from '@/lib/helpers/helperFunctions'
import companyMessageService from '@/lib/services/companyMessageService'
import { CompanyProfileItem } from '@/types/responses/companies'

interface Props {
  company: CompanyProfileItem['company']
}

const ContactCompanyDropdown: React.FC<Props> = ({ company }) => {
  const isCompanyMessagingEnabledQuery = useQuery({
    queryKey: ['company-message-default', { toCompanyId: company?.id }],
    queryFn: () => {
      const companyId = company?.id ?? 0
      return companyMessageService.getCompanyMessageEnabledStatus(companyId)
    },
  })

  const scheduleCallUrl = toSafeHttpUrl(company?.scheduleCompanyCallUrl)

  const {
    isShowingDialog: isShowingContactCompanyDialog,
    showDialog: showContactCompanyDialog,
    hideDialog: hideContactCompanyDialog,
  } = useDialog()

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline-secondary" size="lg">
            <LuMail />
            Contact company
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="z-99999" align="end">
          <DropdownMenuGroup>
            <DropdownMenuItem asChild disabled={!scheduleCallUrl}>
              <a
                href={scheduleCallUrl || '#'}
                target="_blank"
                rel="noreferrer"
                className="text-inherit"
              >
                <LuPhone />
                Schedule call
              </a>
            </DropdownMenuItem>

            <DropdownMenuItem
              disabled={
                company == null ||
                isCompanyMessagingEnabledQuery.isLoading ||
                !isCompanyMessagingEnabledQuery?.data?.enabled
              }
              onClick={showContactCompanyDialog}
            >
              <LuMail />
              Message
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>

      {isShowingContactCompanyDialog && (
        <ContactCompanyModal
          toCompanyId={company?.id ?? 0}
          toCompanyName={company?.name ?? ''}
          handleClose={hideContactCompanyDialog}
        />
      )}
    </>
  )
}

export default ContactCompanyDropdown
